import React from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { injectIntl } from 'react-intl';
import { DragDropContext } from 'react-beautiful-dnd';

let DevTools = () => null;

// Uncomment the following code if you want to enable mobx react dev tools
// in your development environment

// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
//   DevTools = require("mobx-react-devtools").default;
// } else {
//   DevTools = () => null;
// }

////////////////////////////////////////////////////////////////////////////

import BsAlert from '../common_components/BsAlert';
import Lanes from './Lanes';
import ModalSwitch from './ModalSwitch';
import Loading from './Loading';
import SaveButtonWithConfirmation from '../common_components/SaveButtonWithConfirmation';
import { INSTRUCTIONAL_ROUTES } from '../instructional_feed_components/constants';
import { RenderInstructional } from '../instructional_feed_components/RenderInstructional';

@injectIntl
@inject('rootStore')
@observer
export default class Show extends React.Component {
  constructor(props) {
    super(props);

    this.rootStore = props.rootStore;
    this.canEdit = props.rootStore.authorizationStore.canUpdate;
  }

  renderFinishButton = () => {
    const { intl, rootStore } = this.props;

    return (
      <SaveButtonWithConfirmation
        toggleButtonClassName="btn-primary"
        onConfirm={() =>
          (window.location = `${INSTRUCTIONAL_ROUTES.products(
            intl.locale,
            rootStore.valueProposition.id,
          )}`)
        }
      />
    );
  };

  render() {
    const params = new URLSearchParams(window.location.search);
    const modal = params.get('modal');

    return (
      <DragDropContext
        onDragEnd={this.onDragEnd}
        onDragStart={this.onDragStart}
      >
        <BsAlert rootStore={this.rootStore} />
        <DevTools />
        <div className="react-board">
          {this.rootStore.loading ? (
            <Loading rootStore={this.rootStore} />
          ) : (
            <div className={this.rootStore.boardType}>
              {modal == 'ceo' && this.renderFinishButton()}
              <RenderInstructional section={modal} show={modal == 'ceo'} />
              <Lanes />
              <ModalSwitch />
            </div>
          )}
        </div>
      </DragDropContext>
    );
  }

  onDragStart = result => {
    //console.log("onDragStart");
  };

  @action
  onDragEnd = result => {
    if (!result.destination || !result.source || !this.canEdit) {
      return;
    }

    if (result.type === 'LANE') {
      const sourceLane = this.rootStore.lanes[
        Number(result.source.droppableId)
      ];
      const destinationLane = this.rootStore.lanes[
        Number(result.destination.droppableId)
      ];

      const laneChanged = sourceLane.id !== destinationLane.id;

      const removed = sourceLane.findNoteById(result.draggableId);
      sourceLane.notes.remove(removed);

      sourceLane._decrementNotesCounter();

      destinationLane.notes.splice(result.destination.index, 0, removed);
      removed.laneStore = destinationLane;
      destinationLane.notesCount++;

      destinationLane.updateNotePosition(
        removed,
        result.destination.index,
        laneChanged,
        destinationLane.name,
      );
    } else if (result.type === 'TODO') {
      // recover lane name and note index from droppableId string
      const data = result.source.droppableId.split(' ', 2);
      const sourceLaneName = data[0];
      const sourceNoteIndex = data[1];
      /////////////////////////////////////////////////////////////

      const sourceLane = this.rootStore.getLaneStoreByName(sourceLaneName);
      const sourceNote = sourceLane.notes[sourceNoteIndex];
      const sourceTodoListItems = sourceNote.todoList.items;

      const [removed] = sourceTodoListItems.splice(result.source.index, 1);
      sourceTodoListItems.splice(result.destination.index, 0, removed);

      sourceNote.updateTodoItemPosition(removed, result.destination.index);
    }
  };

  @action
  componentWillMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.rootStore.pathname = window.location.pathname;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);

    // let baseUrl = this.rootStore.pathname;
    //
    // if (baseUrl.search("tasks") !== -1) {
    //     baseUrl = baseUrl.substr(0, baseUrl.search('tasks') - 1);
    //     // baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/'));
    // }
    //window.history.pushState({}, "", baseUrl);
  }

  @action
  updateWindowDimensions = () => {
    this.rootStore.windowsDimensions = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  };
}

Show.propTypes = {};
